<template>
	<div class="custom-switcher">
		<input
			:id="this.id"
			:value="value"
			class="custom-switcher__input"
			type="checkbox"
			@click="toggle"
			@keydown.space.prevent="toggle"
			:checked="isChecked"
		/>
		<label :for="this.id" class="custom-switcher__label"></label>
	</div>
</template>

<script>
export default {
	name: 'CustomSwitcher',
	props: {
		value: {
			type: Boolean,
			required: true,
			default: false,
		},
		id: {
			type: String,
			default: '',
		},
	},
	methods: {
		toggle() {
			this.$emit('input', !this.value)
		},
	},
	computed: {
		isChecked: function () {
			return this.value
		},
	},
}
</script>

<style lang="scss">
.custom-switcher {
	&__input {
		display: none;
	}

	&__label {
		position: relative;
		display: block;
		margin: 0;
		width: 56px;
		height: 34px;
		border-radius: 17px;
		background: #d8d8d8;
		transition: background 0.2s;
		cursor: pointer;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	&__label:before {
		content: '';
		position: absolute;
		left: 5px;
		top: 50%;
		transform: translate(0, -50%);
		width: 27px;
		height: 27px;
		border-radius: 50%;
		background: #ffffff;
		box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15), 0 3px 1px rgba(0, 0, 0, 0.06);
		transition: left 0.2s;
	}

	&__input:checked + &__label {
		background: var(--accent-color);
	}

	&__input:checked + &__label:before {
		left: calc(100% - 32px);
	}
}
</style>
